export default __webpack_public_path__ + "static/media/23.e22a80bb.jpg";